/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-25 VN — WEB-20261025-suzitee-uploadbox2
   Đã làm (v2, "làm y hệt Wanderprints"): vào mỗi ô upload ảnh Customily, CHÈN thêm phần tử của mình (không đụng node/handler Customily):
   - chữ "Add a photo to personalize" + ảnh nhỏ 70px của ảnh khách vừa chọn + nút cam "Edit" (cuộn tới bộ nút xoay/zoom/dịch ảnh
     có sẵn của Customily dưới hình SP; SP không có bộ nút đó → mở popup Preview có sẵn của trang);
   - link "View Photo Guide" ở dòng tiêu đề (mở popup Photo Guide bố cục như WP) + 4 dòng hướng dẫn xám + dòng lỗi "Please upload a photo".
   Ảnh nhỏ lấy từ file khách chọn (URL.createObjectURL, không upload thêm, không fetch).
   Observer hẹp trên #customily-options (childList), gom rAF, chỉ chèn khi thiếu → không tự kích vòng lặp.
   Tắt khẩn: ?szub=0 */
(function () {
  'use strict';
  try {
    if (/[?&]szub=0\b/.test(location.search)) return;
    if (window.__szUB) return;
    window.__szUB = { v: 2 };
    document.documentElement.classList.add('szub');

    var BOX = '[data-testid^="image-upload-container"]';
    var HELP = '1. Click Upload Photo to upload your photo or Replace if you\'d like to select a different one.\n' +
      '2. Adjust the photo\'s position (rotate, zoom out/in, move up/down/right/left) using the buttons below the preview image.\n' +
      '3. Make sure your photo is high-quality, in focus, well-lit, and free from blur marks or creases.\n' +
      '4. The Background Remove function will be available 10–30 seconds after you upload.';
    // AI Agent làm theo chỉ thị của anh Hoá — 2026-10-25 22:30 VN — WEB-20261025-suzitee-uploadbox2b
    // Đã làm: popup Photo Guide mục 3 thêm hàng 4 ảnh mẫu nhỏ (✓ rõ nét / ✗ mờ / ✗ tối / ✗ xa) giống WP.
    // Ảnh = asset theme (webp 240px, 1–15KB), URL suy từ src của chính file JS này; <img> chỉ tạo khi khách mở popup lần đầu
    // (buildModal) → PDP không tải thêm byte nào nếu không mở popup.
    var ASSET = (function () {
      var s = document.currentScript || document.querySelector('script[src*="sz-uploadbox.js"]');
      var u = s && s.src ? s.src.split('?')[0] : '';
      return u ? u.replace(/sz-uploadbox\.js$/, '') : '';
    })();
    var EXAMPLES = [['good', 1, 'Clear &amp; bright'], ['blur', 0, 'Blurry'], ['dark', 0, 'Too dark'], ['far', 0, 'Too far']];
    function exRow() {
      if (!ASSET) return '';
      var h = '<span class="szub-ex">';
      for (var i = 0; i < EXAMPLES.length; i++) {
        var x = EXAMPLES[i];
        h += '<span class="szub-ex-i ' + (x[1] ? 'szub-ok' : 'szub-no') + '"><span class="szub-ex-f"><img src="' + ASSET + 'sz-pg-' + x[0] + '.webp" alt="' +
          (x[1] ? 'Good photo: ' : 'Bad photo: ') + x[2] + '" width="240" height="240" decoding="async"></span><span class="szub-ex-l">' + x[2] + '</span></span>';
      }
      return h + '</span>';
    }
    var root = null, obs = null, queued = false, modal = null, lastFocus = null;
    var thumbs = {}; // data-testid → blob URL ảnh khách chọn
    var bad = {};    // src ảnh trình duyệt không vẽ được (vd HEIC) → không gắn lại (tránh vòng onerror → chèn lại)

    function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; return e; }
    var X_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
    var WARN_SVG = '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 4 2 44h44z" fill="#ffd21f" stroke="#0a1c39" stroke-width="2.5" stroke-linejoin="round"/><path d="M24 17v14" stroke="#0a1c39" stroke-width="4.5" stroke-linecap="round"/><circle cx="24" cy="37.5" r="2.8" fill="#0a1c39"/></svg>';

    // AI Agent làm theo chỉ thị của anh Hoá — 2026-10-26 01:30 VN — WEB-20261026-suzitee-uploadbox2c
    // Đã làm: mục 2 popup — hàng icon cũ (8 nút, icon lệch góc trên-trái vì luật "li i{display:block}" đè) → đúng 7 nút chỉnh ảnh
    // thật của Suzitee theo đúng thứ tự (thu, phóng, xoay, phải, trái, xuống, lên), icon căn giữa ô vuông, chia 3 nhóm có chữ nhỏ
    // Zoom / Rotate / Move. Dùng <span> thay <i> để không dính kiểu chữ nghiêng của dòng phụ mục 1. Chỉ minh hoạ, không bấm được.
    function ic(d) { return '<span class="szub-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg></span>'; }
    function grp(lbl, icons) { return '<span class="szub-g"><span class="szub-gi">' + icons + '</span><span class="szub-gc">' + lbl + '</span></span>'; }
    var ICONS = grp('Zoom', ic('<circle cx="10.5" cy="10.5" r="6.5"/><path d="m20 20-4.6-4.6M7.5 10.5h6"/>') + ic('<circle cx="10.5" cy="10.5" r="6.5"/><path d="m20 20-4.6-4.6M7.5 10.5h6M10.5 7.5v6"/>')) +
      grp('Rotate', ic('<path d="M4.5 12a7.5 7.5 0 1 0 2.2-5.3"/><path d="M4.5 4.5v4h4"/>')) +
      grp('Move', ic('<path d="M5 12h14M13 6l6 6-6 6"/>') + ic('<path d="M19 12H5M11 6l-6 6 6 6"/>') + ic('<path d="M12 5v14M6 13l6 6 6-6"/>') + ic('<path d="M12 19V5M6 11l6-6 6 6"/>'));

    function logoSrc() {
      var i = document.querySelector('header img[src*="logo"], .logo img, [class*="logo"] img');
      return i ? (i.currentSrc || i.src) : '';
    }
    function buildModal() {
      modal = el('div', 'szub-m');
      modal.hidden = true;
      var lg = logoSrc();
      modal.innerHTML =
        '<div class="szub-d" role="dialog" aria-modal="true" aria-labelledby="szub-ttl" tabindex="-1">' +
        '<button type="button" class="szub-x" aria-label="Close">' + X_SVG + '</button>' +
        '<div class="szub-hd">' + (lg ? '<img src="' + lg + '" alt="Suzitee" width="160" height="52">' : '') + '<h2 id="szub-ttl">Photo Guide</h2></div>' +
        '<ol>' +
        '<li>Click <b>Upload Photo</b> to upload, or <b>Replace</b> to choose a different one.<i>Multi-photo designs support multiple uploads.</i></li>' +
        // AI Agent làm theo chỉ thị của anh Hoá — 2026-10-26 11:20 VN — WEB-20261026-suzitee-uploadbox2d-1line
        // Đã làm: chữ mục 2 rút còn đúng tiêu đề đậm của WP "Adjust the photo's position" (bỏ đoạn "— rotate, zoom, or move it using the buttons below.") để luôn 1 dòng ở 390/430/1280/1440.
        '<li><b>Adjust the photo\'s position</b>' +
        '<span class="szub-row" aria-hidden="true">' + ICONS + '</span></li>' +
        '<li>Use a <b>high-quality, well-lit photo</b> — clear face, in focus, no blur marks or creases.' + exRow() + '</li>' +
        '<li>Photos using <b>Background Removal</b> may take <b>10–30 seconds</b> to process after you upload.</li>' +
        '</ol>' +
        '<div class="szub-n">' + WARN_SVG + '<div><b>Can’t upload your photo?</b>Add the item to your cart and check out as usual. Send us your order number &amp; photo via <a href="/pages/contact" target="_blank" rel="noopener">Contact Us</a> or <a href="mailto:support@suzitee.com">support@suzitee.com</a>—we’ll process it manually at no extra cost.</div></div>' +
        '<p class="szub-p">Your photo is only used to create your order — never shared, sold, or used for anything else.</p>' +
        '</div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.szub-x')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
    }
    function openGuide(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (!modal) buildModal();
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('szub-lock');
      modal.querySelector('.szub-d').scrollTop = 0;
      var x = modal.querySelector('.szub-x'); if (x) x.focus({ preventScroll: true });
    }
    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('szub-lock');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (_) {} }
    }
    window.__szUB.open = openGuide;

    // "Edit": tới bộ nút chỉnh ảnh của Customily (dưới hình SP), nháy viền 1,6s; không có → mở popup Preview của trang
    function edit(e) {
      e.preventDefault(); e.stopPropagation();
      var c = document.querySelector('.customily-mobile-controls');
      if (c && c.offsetParent) {
        var w = c.closest('.canvas-container') || c;
        w.scrollIntoView({ behavior: 'smooth', block: 'center' });
        c.classList.remove('szub-flash'); void c.offsetWidth; c.classList.add('szub-flash');
        setTimeout(function () { c.classList.remove('szub-flash'); }, 1700);
        return;
      }
      var b = document.getElementById('customily-preview-button');
      if (b) b.click();
    }
    // AI Agent làm theo chỉ thị của anh Hoá — 2026-10-26 15:00 VN — WEB-20261026-suzitee-wpthumb
    // Đã làm: ảnh nhỏ trong ô upload sau khi khách bấm "Yes" khôi phục thiết kế — trước: chỉ có ảnh khi khách vừa chọn file
    // ở lần xem này (blob), khôi phục thì không có file → ô xám icon. Nay: không có blob → lấy URL ảnh Customily đã khôi phục
    // từ bản lưu của chính Customily (localStorage 'customily-<id>', option "Image Upload" cùng setId + id ô) và hiện ảnh đó.
    // Chỉ ĐỌC bản lưu, không ghi/không điền form; ảnh khách chọn mới (blob) vẫn ưu tiên; URL lỗi → về ô xám như cũ.
    var lsRaw = {}, lsMap = {};
    function savedSrc(b) {
      var t = b.getAttribute('data-testid') || '';
      var m = t.match(/^image-upload-container-(.+)-(\d+)$/);
      if (!m) return '';
      var best = '', bestTs = -1;
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (!/^customily-\d+$/.test(k)) continue;
          var raw = localStorage.getItem(k);
          if (raw !== lsRaw[k]) { lsRaw[k] = raw; lsMap[k] = null; try { lsMap[k] = JSON.parse(raw); } catch (_) {} }
          var d = lsMap[k], os = d && d.options;
          if (!os || !os.length) continue;
          for (var j = 0; j < os.length; j++) {
            var o = os[j];
            if (o && o.type === 'Image Upload' && o.setId === m[1] && String(o.id) === m[2] &&
              typeof o.value === 'string' && /^https:\/\/[^\s"'<>]+$/.test(o.value) && (+d.timestamp || 0) > bestTs) {
              best = o.value; bestTs = +d.timestamp || 0;
            }
          }
        }
      } catch (_) {}
      return best;
    }
    function setThumb(b) {
      var th = b.querySelector(':scope > .szub-th');
      if (!th) return;
      var src = thumbs[b.getAttribute('data-testid')];
      if (!src) { var s = b.querySelector('.szup-ic img'); if (s && s.src) src = s.src; } // dự phòng: ảnh của ô tiến độ
      if (!src && b.querySelector('.cl_remove-image')) src = savedSrc(b); // WPTHUMB: ảnh đã khôi phục từ bản lưu Customily
      var img = th.querySelector('img');
      if (!src || bad[src]) { if (img) img.remove(); return; }
      if (img && img.getAttribute('src') === src) return;
      if (!img) { img = el('img'); img.alt = 'Uploaded preview'; img.decoding = 'async'; img.onerror = function () { bad[this.getAttribute('src')] = 1; this.remove(); }; th.appendChild(img); }
      img.src = src;
    }

    // chèn phần tử của mình vào từng ô upload còn thiếu (idempotent)
    function scan() {
      queued = false;
      if (!root) return;
      var boxes = root.querySelectorAll(BOX);
      for (var i = 0; i < boxes.length; i++) {
        var b = boxes[i];
        if (!b.querySelector('input[type=file]')) continue;
        var o = b.closest('.customily_option');
        if (!o) continue;
        if (!o.classList.contains('szub-o')) o.classList.add('szub-o');
        if (!b.querySelector(':scope > .szub-t')) b.appendChild(el('div', 'szub-t', 'Add a photo to personalize'));
        if (!b.querySelector(':scope > .szub-th')) b.appendChild(el('div', 'szub-th'));
        if (!b.querySelector(':scope > .szub-pv')) {
          var pv = el('button', 'szub-pv', 'Edit'); pv.type = 'button';
          pv.addEventListener('click', edit);
          b.appendChild(pv);
        }
        setThumb(b);
        var lb = o.querySelector(':scope > label');
        var hasGuide = !!(lb && lb.querySelector(':scope > .szub-gl'));
        if (lb && !hasGuide) {
          // nút nằm trong <label> của Customily: click không lan lên label (stopPropagation trong openGuide)
          var g = el('button', 'szub-gl', 'View Photo Guide'); g.type = 'button'; g.setAttribute('aria-haspopup', 'dialog');
          g.addEventListener('click', openGuide);
          lb.appendChild(g);
          hasGuide = true;
        }
        var nx = b.nextElementSibling;
        if (!nx || !nx.classList.contains('szub-err')) {
          var er = el('div', 'szub-err', 'Please upload a photo'); er.setAttribute('role', 'alert');
          b.parentNode.insertBefore(er, b.nextSibling);
          nx = er;
        }
        // AI Agent làm theo chỉ thị của anh Hoá — 2026-10-25 22:30 VN — WEB-20261025-suzitee-uploadbox2b
        // Đã làm: bỏ 4 dòng hướng dẫn xám dưới khung khi ô đã có link "View Photo Guide" (trùng nội dung popup).
        // Đoạn này do chính file này chèn (.szub-help), không phải help text Customily → không đụng dữ liệu Customily.
        // Ô không có <label> (không chèn được link) → vẫn giữ 4 dòng như cũ.
        var hx = nx.nextElementSibling;
        if (hasGuide) {
          if (hx && hx.classList.contains('szub-help')) hx.remove();
        } else if (!hx || !hx.classList.contains('szub-help')) {
          var h = el('div', 'szub-help'); h.textContent = HELP;
          b.parentNode.insertBefore(h, nx.nextSibling);
        }
      }
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }

    function onChange(e) {
      var t = e.target;
      if (!t || t.type !== 'file' || !t.files || !t.files[0]) return;
      var b = t.closest(BOX); if (!b) return;
      var k = b.getAttribute('data-testid');
      try { if (thumbs[k]) URL.revokeObjectURL(thumbs[k]); thumbs[k] = URL.createObjectURL(t.files[0]); } catch (_) {}
      queue();
    }

    function attach() {
      var r = document.getElementById('customily-options');
      if (r && r !== root) {
        root = r;
        if (obs) obs.disconnect();
        obs = new MutationObserver(queue);
        obs.observe(root, { childList: true, subtree: true });
        root.addEventListener('change', onChange, true);
        queue();
      }
    }
    attach();
    // AI Agent làm theo chỉ thị của anh Hoá — 2026-11-02 16:20 VN — WEB-20261102-suzitee-formflash
    // Đã làm: #customily-options chưa có lúc file chạy → trước chỉ dò 1s/lần (link "View Photo Guide"/chữ chèn trễ tới 1s);
    // nay thêm observer tạm trên document (callback chỉ gọi getElementById) bắt ngay lúc khung xuất hiện, gắn xong là ngắt.
    // Giao diện ô upload đã áp bằng CSS từ <head> (sz-uploadbox.css) nên không còn lộ form cũ dù JS chậm; dò 1s/lần giữ nguyên làm dự phòng.
    if (!root) {
      var mo0 = new MutationObserver(function () { if (document.getElementById('customily-options')) { mo0.disconnect(); attach(); } });
      mo0.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { mo0.disconnect(); }, 60000);
    }
    // v5: WebKit/Safari — bấm ATC thiếu ô: cú cuộn smooth của Customily tới ô thiếu đầu tiên bị kéo ngược về nút ATC (QC 25/10, tắt ?szub=0 thì không bị).
    // 700ms sau báo thiếu, nếu ô thiếu đầu tiên vẫn ngoài màn hình → cuộn lại đúng vị trí Customily nhắm (giữa màn hình). Chrome đã tới nơi → không làm gì.
    // WPTHUMB: Customily nạp xong thiết kế khôi phục → quét lại để gắn ảnh nhỏ (phòng khi DOM đổi trước lúc bản lưu sẵn)
    window.addEventListener('customily-load-customization-finished', queue);
    window.addEventListener('customily-required-error', function () {
      setTimeout(function () {
        try {
          if (!root) return;
          var os = root.querySelectorAll('.customily_option'), o = null;
          for (var i = 0; i < os.length; i++) {
            var sp = os[i].querySelector('.customily-required-label > span');
            if (os[i].offsetHeight && sp && sp.style.display !== 'none') { o = os[i]; break; }
          }
          if (!o) return;
          var r = o.getBoundingClientRect();
          if (r.top >= -40 && r.top <= innerHeight - 80) return;
          window.scrollTo({ top: r.top + window.pageYOffset - innerHeight / 2 + r.height / 2, behavior: 'smooth' });
        } catch (_) {}
      }, 700);
    });
    // #customily-options do app dựng muộn / có thể bị thay → dò 1s/lần, tối đa 5 phút
    var n = 0, t = setInterval(function () { try { attach(); } catch (_) {} if (++n > 300) clearInterval(t); }, 1000);
  } catch (err) {
    try { document.documentElement.classList.remove('szub'); } catch (_) {}
  }
})();
